// Simple in-memory intent manager for short-lived intents (like resume after login)
const intents = new Map();

export const registerIntent = (id, fn) => {
  if (!id || typeof fn !== 'function') return false;
  intents.set(id, fn);
  return true;
};

export const consumeIntent = (id) => {
  if (!id) return false;
  const fn = intents.get(id);
  if (typeof fn === 'function') {
    try {
      fn();
    } catch (err) {
      // swallow error - caller may log
      // eslint-disable-next-line no-console
      console.error('Intent handler threw error', err);
    }
    intents.delete(id);
    return true;
  }
  return false;
};

export const hasIntent = (id) => intents.has(id);

export default {
  registerIntent,
  consumeIntent,
  hasIntent,
};
